<div class="header">
  <h1>Tags</h1>
  <button mat-button type="button" (click)="openCreateTagDialog()">New Tag</button>
</div>

<ng-container *ngIf="tags$ | async as tags; else loadingOrError">
  <ng-container *ngIf="tags.length; else empty">
    <div class="tags-container">
      <span *ngFor="let tag of tags" [routerLink]="[nav_path.adminTags, tag.slug, 'edit']" class="tag" [matBadge]="tag?.stories?.length">{{tag.slug}}</span>
    </div>
  </ng-container>

  <ng-template #empty>
    <div class="card">
      <h2 class="">No tags yet!</h2>
      <p class="">Create the first tag to get us started.</p>
      <div class="btn-container">
        <button type="button" mat-button (click)="openCreateTagDialog()">Create New Tag</button>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-template #loadingOrError>
  <anon-loading-or-error [error]="error"></anon-loading-or-error>
</ng-template>
